import { useEffect, useState } from 'react';
import VoxelToolbar from './VoxelToolbar';
import VoxelEditor from 'scripts/scenes/voxel-editor';
import { useNavigate, useLocation } from 'react-router';
import Engine from 'scripts/engine/engine';
import voxTemplates from 'scripts/objects/voxel-planet/templates';

function VoxelPlanetViewer() {
    const navigate = useNavigate();
    const location = useLocation();
    const [scene, setScene] = useState<VoxelEditor>();

    // Load planet data
    useEffect(() => {
        Engine.instance.curtain.fadeIn(1.0);
    }, [location.search, navigate])

    useEffect(() => {
        const newScene = new VoxelEditor();
        const planetData = localStorage.getItem("voxelPlanetData") || voxTemplates.default;
        newScene.loadData(planetData, true);
        setScene(newScene);

        return () => {
            if(newScene) {
                newScene.dispose();
            }
        }
    }, [])

    return (
        <div id="planet-viewer-component">
            {scene && <VoxelToolbar editor={scene}/>}
        </div>
    );
}

export default VoxelPlanetViewer;
